import { CampaignUserState } from '@bvengineering/cas-member-gateway-service-client';

// States where the creator is actively enrolled — used to decide whether to
// redirect away from the invite screen
export const ACTIVE_CAMPAIGN_USER_STATES = [
  CampaignUserState.Available,
  CampaignUserState.Participating,
  CampaignUserState.Completed,
  CampaignUserState.Paused,
] as const;

export type OAuthStatus = 'loading' | 'success' | 'error';

// User and Authentication Types
export interface User {
  id: string;
  email: string;
  instagramHandle?: string;
  avatar?: string;
  memberType: 'creator' | 'member';
  createdAt: string;
  updatedAt: string;
}

// Magic Link Invite Types
// Note: This is used for the /campaigns/creators/summary endpoint which is not in the SDK
export interface MagicLinkInviteProduct {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  brand: string;
}

export interface MagicLinkInvite {
  campaignId: number;
  campaignName: string;
  campaignDescription: string;
  creatorId: number;
  inviteId: number;
  username: string;
  /** Social platform, e.g. "INSTAGRAM", "TIKTOK" */
  platform: string;
  products: MagicLinkInviteProduct[];
  campaignUserState: CampaignUserState | null;
  /** Current status of the invite, e.g. "PENDING", "PARTICIPATING", "DECLINED" */
  inviteStatus?: string;
  /** Creator's assigned email address */
  email?: string | null;
  hasSignedInBefore?: boolean;
}

// =============================================================================
// SDK Types Re-exports
// For convenience, commonly used SDK types can be imported from here or directly
// from the hooks/services that export them.
// =============================================================================

// Campaign types are available from:
// - @/api: CampaignListResponse, CampaignServiceCampaignDetail, ListCampaignResponseItem

// Member/Profile types are available from:
// - @/api: GetMyInfoResponse, UpdateMemberProfileRequest

// Social connection types are available from:
// - @/api: SocialProvider

// Address types are available from:
// - @/api: CreateUserVerifiedAddressRequest, CreateUserVerifiedAddressResponse, GetUserVerifiedAddressesResponse
